/**
 * Reconnect delay for attempt `n` (1-based), in milliseconds.
 *
 * Exponential, capped, and jittered. The jitter is not a detail: without it, every tab
 * that lost a connection at the same moment -- which is what a deploy or a load-balancer
 * restart causes -- retries in lockstep and the server is hit by a synchronised wave each
 * time. Spreading each delay across the back half of its window turns a thundering herd
 * into a trickle.
 */
export function reconnectDelayMs(
  attempt: number,
  options: { baseMs?: number; maxMs?: number; random?: () => number } = {},
): number {
  const { baseMs = 1000, maxMs = 30_000, random = Math.random } = options;
  const exponential = Math.min(baseMs * 2 ** (attempt - 1), maxMs);
  return exponential / 2 + random() * (exponential / 2);
}
